"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatFeature = void 0;
const ChatFeature = exports.ChatFeature = {
  /** Turns on Genesys web messenger on the site. */
  UseWebMessenger: '5572F655-0F6D-4D81-8EAD-05AB7474B309',
  /** Defines whenever a Genesys Web Messaging client will be used on site as a client application in Appshell. */
  UseWebMessengerAsClientApp: '6F8FF762-F8FA-4AE4-998D-46A7C59BB276'
};
